import { render, staticRenderFns } from "./SsoHandoff.vue?vue&type=template&id=2de5a147&scoped=true"
import script from "./SsoHandoff.vue?vue&type=script&lang=js"
export * from "./SsoHandoff.vue?vue&type=script&lang=js"
import style0 from "./SsoHandoff.vue?vue&type=style&index=0&id=2de5a147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5a147",
  null
  
)

export default component.exports